module.exports = __webpack_public_path__ + "static/probodel-f1681cb50317fb5410ba316f6698e7ea.jpg";